module.exports = __webpack_public_path__ + "static/media/ils_wip.cecbff2e.svg";